import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import Nav from "./components/Nav";
import LeadWidgets from "./components/LeadWidgets";
import OfferPopup from "./components/OfferPopup";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import Studio from "./pages/Studio";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPackages from "./pages/AdminPackages";
import AdminCoupons from "./pages/AdminCoupons";
import AdminPayments from "./pages/AdminPayments";
import AdminUsers from "./pages/AdminUsers";
import AdminLeads from "./pages/AdminLeads";
import AdminVisitors from "./pages/AdminVisitors";
import SeoLanding from "./components/SeoLanding";
import NotFound from "./pages/NotFound";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Offer from "./pages/Offer";
import seo from "./seo/pages.json";
import Help from "./pages/Help";
import useVisitorTracking from "./hooks/useVisitorTracking";
import "./App.css";

// The app used to run on hash URLs (idcardgen.com/#/pricing). Keep old
// bookmarks and shared links working by moving "#/path" into the real path
// before the router reads it.
if (typeof window !== "undefined" && window.location.hash.startsWith("#/")) {
    window.history.replaceState(null, "", window.location.hash.slice(1));
}

const landingPaths = seo.pages.filter((p) => p.landing).map((p) => p.path);

function VisitorTracker() {
    useVisitorTracking();
    return null;
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <VisitorTracker />
                <Nav />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/offer" element={<Offer />} />
                    {landingPaths.map((path) => (
                        <Route
                            key={path}
                            path={path}
                            element={<SeoLanding key={path} path={path} />}
                        />
                    ))}
                    <Route path="/help" element={<Help />} />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/studio"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/studio/:tid"
                        element={
                            <ProtectedRoute>
                                <Studio />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/packages"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminPackages />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/coupons"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminCoupons />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/payments"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminPayments />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/users"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminUsers />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/leads"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminLeads />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/visitors"
                        element={
                            <ProtectedRoute role="admin">
                                <AdminVisitors />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="*" element={<NotFound />} />
                </Routes>
                <LeadWidgets />
                <OfferPopup />
                <Toaster position="bottom-right" richColors />
            </BrowserRouter>
        </AuthProvider>
    );
}
